import { Component, h } from 'preact'
import axios from 'axios'
import CategoryListItem from './CategoryListItem'
import ShowMoreButton from '../ui-components/ShowMoreButton'

type Category = {
  id: number,
  title: string
}

interface Props {
  id: number
}

interface State {
  list: Array<Category>,
  displayedAllItems: boolean
}

class CategoryList extends Component<Props, State> {
  constructor () {
    super()
    this.maxItem = 6
    this.state = {
      list: [],
      displayedAllItems: true
    }
    this.showMore = this.showMore.bind(this)
  }

  maxItem: number

  async componentDidMount () {
    const { data } = await axios.get('/category/list', {
      params: {
        id: this.props.id
      }
    })

    this.setState({ list: data, displayedAllItems: data.length <= this.maxItem })
  }

  showMore () {
    this.setState({ displayedAllItems: true })
  }

  render (props: Props, { displayedAllItems, list }: State) {
    const displayList = displayedAllItems ? list : list.slice(0, this.maxItem)
    return (
      <div className='category-page_container'>
        <ul className='category-page_list'>
          {
            displayList.map((item) => <CategoryListItem {...item} />)
          }
        </ul>
        {
          !displayedAllItems ? <ShowMoreButton callback={this.showMore} count={list.length - this.maxItem} /> : null
        }
      </div>
    )
  }
}

export default CategoryList
